import type { useAgentSessionsLiveUpdatesSubscription as Subscription } from './__generated__/useAgentSessionsLiveUpdatesSubscription.graphql';
import type { AgentSessionsLiveEvent } from './observeAgentSessionsLiveEvents';

const nonBlank = (value: string | null | undefined): string | undefined => {
	const trimmed = value?.trim();
	return trimmed ? trimmed : undefined;
};

export const getConversationChannelLiveEvent = (
	conversationChannel: AgentSessionsLiveEvent['conversationChannel'],
): AgentSessionsLiveEvent => ({
	conversationId: nonBlank(conversationChannel?.id),
	...(typeof conversationChannel?.readStatus === 'boolean'
		? { readStatus: conversationChannel.readStatus }
		: {}),
	...(conversationChannel === undefined ? {} : { conversationChannel }),
});

export const getAgentSessionsLiveEvent = (
	response: Subscription['response'] | null | undefined,
): AgentSessionsLiveEvent | null => {
	const change = response?.convoai_onInboxSessionChanged;
	if (change == null) return null;
	return getConversationChannelLiveEvent(change.session?.conversationChannel);
};
